/**
 * AddMoreButton Component
 *
 * A button component that allows users to add more items or entries.
 * This component triggers a specified function when clicked.
 *
 * Author: Mamta
 * Date: 7th October 2024
 */

import React from "react";
import "./elements.css";

const AddButton = ({ onClick, className }) => {
  return (
    <button className={className} style={buttonStyle} onClick={onClick}>
      + Add
    </button>
  );
};

const buttonStyle = {
  display: "flex",
  width: "150px",
  height: "30px",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid #bcab79",
  background: "#fff",
  color: "#bcab79",
  fontSize: "15px",
  fontWeight: "500",
  cursor: "pointer",
};

export default AddButton;
